export default __webpack_public_path__ + "media/plus/test-plus-twenty-gb-frame-05114475.png";